<template>
	<div>
		{{ getFormattedData() }}
	</div>
</template>

<script>
import erm from '@/components/UIComponents/EventDataRenderers/EventRenderersMethods.js';

export default {
	name: 'CourseStartedWithoutVehicleRenderer',
	props: {
		eventType: {
			type: String,
			required: true,
		},
		eventData: {
			type: String,
			required: true,
		}
	},
	methods: {
		getFormattedData() {
            let eventDescription = erm.getTranslationForEventDescription(this.eventType);
            return eventDescription ? eventDescription : this.eventData;
		}
	}
}
</script>